import script from "./SelectTour.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectTour.vue?vue&type=script&setup=true&lang=js"

import "./SelectTour.vue?vue&type=style&index=0&id=0b22b4c1&scoped=true&lang=css"

import exportComponent from "/Users/zane/Dev/ionic-spirit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b22b4c1"]])

export default __exports__